import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const PolicyPageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
            contents: [
                {
                    field: "policies",
                    partial: {
                        handler: (props)=> {
                            return props.formHandler.buildArrayInputs("contents", "policies", "قوانین", {
                                content:{
                                    type: "text_area",
                                    props: {
                                        rows: 5
                                    },
                                    label: "محتوی"
                                },
                                title: {
                                    label: "عنوان"
                                },
                            })
                        },
                    }
                }
            ]
        }
    }
};

export default PolicyPageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/PolicyPageBuilder.js